import {map_key} from './config'
import axios from 'axios'
import {Notify} from 'vant'
import {getConfig} from '@/api/api'
import wx from '@/libs/sdk-h5-weixin'

export const getLocation = () => {
  return new Promise((resolve) => {
      wx.getLocation((successRes, failRes) => {
        if (successRes) {
          console.log('getLocationSuccess', successRes)
          var latitude = successRes.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = successRes.longitude; // 经度，浮点数，范围为180 ~ -180。
          axios.get(`https://restapi.amap.com/v3/geocode/regeo?key=${map_key}&location=${longitude},${latitude}&batch=false&extensions=base`).then(res => {
            let data = res.data.regeocode.addressComponent
            let city
            if (data.city.length > 0) {
              if (Array.isArray(data.city)) {
                city = data.city[0]
              } else {
                city = data.city
              }
            } else {
              city = data.province
            }
            console.log('city', city)
            getConfig({
              locationType: 1,
              location: data.province + city
            })
            resolve({ data: { city } })
          }).catch(() => {
            Notify('获取定位失败，请自行选择城市')
            resolve(null)
          })
        } else {
          axios
            .get(`https://restapi.amap.com/v3/ip?key=${map_key}`)
            .then((result) => {
              console.log(result)
              if (result.data.status === '1'
                && result.data.city
                && result.data.city.length > 0) {
                resolve({ data: { city: result.data.city } })
              } else {
                Notify('获取定位失败，请自行选择城市')
                resolve(null)
              }
            })
            .catch(() => {
              Notify('获取定位失败，请自行选择城市')
              resolve(null)
            })
        }
      })

  })
}
